import i18n from '@/helpers/i18n';

export default [
  {
    _name: 'CSidebarNav',
    _children: [ 
      {
        _name: 'CSidebarNavTitle',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('occurences'),
        to: '/occurences/list',
        icon: 'cil-check',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('startInfos'),
        to: '/startInfos/list',
        icon: 'cil-pin',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('users'),
        to: '/users/list',
        icon: 'cil-people',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('rankings'),
        to: '/rankings',
        icon: 'cil-grid',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('keyValues'),
        to: '/infos/list',
        icon: 'cil-library',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('staticInfos'),
        to: '/pages/list',
        icon: 'cil-File',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('profile'),
        to: '/profile',
        icon: 'cil-user'
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('bannerAds'),
        href: 'https://www.avozdetrasosmontes.pt/wp-admin/admin.php?page=adrotate-groups&view=edit&group=28',
        target: '_blank',
        icon: 'cil-justifyCenter'
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('fullscreenAds'),
        href: 'https://www.avozdetrasosmontes.pt/wp-admin/admin.php?page=adrotate-groups&view=edit&group=29',
        target: '_blank',
        icon: 'cil-drop'
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('logout'),
        to: '/logout',
        icon: 'cil-power-standby'
      },
      {
        _name: 'CSidebarNavTitle',
      }
    ]
  }
]